import { useTranslation } from 'react-i18next'

import { Status } from '../../Status'
import { CALENDAR_ITEM_KIND_TAG_PROPS } from '../Calendar.constants'

function CalendarItemTag({ item }) {
  const { t } = useTranslation()

  const tagProps = CALENDAR_ITEM_KIND_TAG_PROPS[item.kind]

  return tagProps ? <Status {...tagProps} text={t(tagProps.text)} /> : null
}

export default CalendarItemTag
